// extracted by mini-css-extract-plugin
export default {"wrapper":"searchInput_wrapper__wePr8","input":"searchInput_input__1w8I2","iconBtn":"searchInput_iconBtn__Ias1x","icon":"searchInput_icon__lKZqv"};